export default __webpack_public_path__ + "static/media/facebook.c3cacd60.svg";